export default "__VITE_ASSET__CPMMuxlC__";